export const contactTypeOptions = [
  { ID: 0, Name: 'Unspecified' },
  { ID: 1, Name: 'Operations Manager' },
  { ID: 2, Name: 'Owner' },
  { ID: 3, Name: 'Accounting' },
  { ID: 4, Name: 'Dispatch' },
  { ID: 5, Name: 'Tracking' },
  { ID: 6, Name: 'Safety' },
];

// Editors prompt for a choice instead of offering Unspecified as if it were one.
export const contactTypeEditorOptions = contactTypeOptions.map(
  (option) => option.ID === 0 ? { ...option, Name: 'Select' } : option
);
